import React, { Fragment } from "react";
import classNames from "classnames";

function totalSamplesTested(rows) {
  var sum = 0;
  rows.map((r) => (sum += r.samples_tested));
  return sum;
}

function totalResiduesFound(rows) {
  var sum = 0;
  rows.map((r) => (sum += r.residues_found));
  return sum;
}

const NumberTd = ({ value }) => {
  return <td className={classNames({ positive: value > 0, zero: value == 0 })}>{value}</td>;
};

const TotalTd = ({ rows, field, total }) => {
  var sum = 0;
  rows.map((r) => (sum += r[field]));
  return (
    <td className={classNames("sum", { positive: sum > 0, zero: sum == 0, total })}>{sum}</td>
  );
};

const PercentageTd = ({ rows, field, total }) => {
  var samplesTested = totalSamplesTested(rows);
  var sum = 0;
  rows.map((r) => (sum += r[field]));
  var percentage = sum == 0 ? 0 : Math.round((sum / samplesTested) * 100);
  return (
    <td
      className={classNames("percentage", {
        positive: percentage > 0,
        zero: percentage == 0,
        total,
      })}
    >
      {percentage}
    </td>
  );
};

const ResiduePercentageTd = ({ rows, field, total }) => {
  var residuesFound = totalResiduesFound(rows);
  var sum = 0;
  rows.map((r) => (sum += r[field]));
  var percentage = sum == 0 ? 0 : Math.round((sum / residuesFound) * 100);
  return (
    <td
      className={classNames("percentage", {
        positive: percentage > 0,
        zero: percentage == 0,
        total,
      })}
    >
      {percentage}
    </td>
  );
};

export default function CommodityGroup({
  data,
  attribute_types,
  options = { showTestingBreakdown: false },
}) {
  return (
    <div className="mrl_product_section">
      <a class="anchor" id={data.mrl_product_name.substr(0, 10)} />
      <div className="product_header">{data.mrl_product_name}</div>

      <div className="product_data">
        <table className="table table-bordered table-hover table-condensed commodity_table">
          <thead>
            <tr>
              <th className="empty" colSpan={Math.max(1, attribute_types.length)} />
              <th colSpan={8}>Number Of Samples</th>
              <th colSpan={7}>
                  Number Of Residues
                  <br/>
                  (does not factor in the uncertainty of measurement)
              </th>
              {options.showTestingBreakdown && <th colSpan={6}>Number Of Samples</th>}
            </tr>
            <tr>
              {attribute_types.map((at) => (
                <th key={at.id}>{at.name}</th>
              ))}
              {attribute_types.length == 0 && <th className="empty" />}
              <th>
                Samples <br />
                Tested
              </th>
              <th>Residue Free</th>
              <th>With Residues</th>
              <th>1 - 2 Residues</th>
              <th>3 - 5 Residues</th>
              <th>&gt; 5 Residues</th>
              <th>
                Insecticide
                <br /> Free
              </th>
              <th>
                Fungicide
                <br /> Free
              </th>
              <th>Found</th>
              <th>No MRL</th>
              <th>&lt; 20% MRL</th>
              <th>20% to &lt;50%</th>
              <th>50% to &lt;80%</th>
              <th>80% to &lt;=100%</th>
              <th>&gt; 100%</th>
              {options.showTestingBreakdown && (
                <Fragment>
                  <th>
                    MRPS GC LC
                    <br />
                    &amp; Dithio
                  </th>
                  <th>Chlorate</th>
                  <th>Fosetyl Al</th>
                  <th>Dithianon</th>
                </Fragment>
              )}
            </tr>
          </thead>
          <tbody>
            {data.rows.map((row) => (
              <tr className={"data_row"}>
                {attribute_types.map((at) => (
                  <td>{row.attribute_values.filter((av) => av.id == at.id)[0].value}</td>
                ))}
                {attribute_types.length == 0 && <td className="empty" />}
                <NumberTd value={row.samples_tested} />
                <NumberTd value={row.residue_free} />
                <NumberTd value={row.with_residues} />
                <NumberTd value={row.one_to_two_residues} />
                <NumberTd value={row.three_to_five_residues} />
                <NumberTd value={row.more_than_five_residues} />
                <NumberTd value={row.insecticide_free_count} />
                <NumberTd value={row.fungicide_free_count} />

                <NumberTd value={row.residues_found} />
                <NumberTd value={row.no_mrl} />
                <NumberTd value={row.less_than_20_percent} />
                <NumberTd value={row.twenty_to_fifty_percent} />
                <NumberTd value={row.fifty_to_eighty_percent} />
                <NumberTd value={row.eighty_to_hundred_percent} />
                <NumberTd value={row.above_the_mrl} />

                {options.showTestingBreakdown && (
                  <Fragment>
                    <NumberTd value={row.mrps_gc_lc_dithio_count} />
                    <NumberTd value={row.chlorate_count} />
                    <NumberTd value={row.fosetyl_al_count} />
                    <NumberTd value={row.dithianon_count} />
                  </Fragment>
                )}
              </tr>
            ))}
            <tr className="total_row">
              <td colSpan={attribute_types.length} className="total_title">
                Total:
              </td>
              <TotalTd total rows={data.rows} field={"samples_tested"} />
              <TotalTd rows={data.rows} field={"residue_free"} />
              <TotalTd rows={data.rows} field={"with_residues"} />
              <TotalTd rows={data.rows} field={"one_to_two_residues"} />
              <TotalTd rows={data.rows} field={"three_to_five_residues"} />
              <TotalTd rows={data.rows} field={"more_than_five_residues"} />
              <TotalTd rows={data.rows} field={"insecticide_free_count"} />
              <TotalTd rows={data.rows} field={"fungicide_free_count"} />

              <TotalTd total rows={data.rows} field={"residues_found"} />
              <TotalTd rows={data.rows} field={"no_mrl"} />
              <TotalTd rows={data.rows} field={"less_than_20_percent"} />
              <TotalTd rows={data.rows} field={"twenty_to_fifty_percent"} />
              <TotalTd rows={data.rows} field={"fifty_to_eighty_percent"} />
              <TotalTd rows={data.rows} field={"eighty_to_hundred_percent"} />
              <TotalTd rows={data.rows} field={"above_the_mrl"} />

              {options.showTestingBreakdown && (
                <Fragment>
                  <TotalTd rows={data.rows} field={"mrps_gc_lc_dithio_count"} />
                  <TotalTd rows={data.rows} field={"chlorate_count"} />
                  <TotalTd rows={data.rows} field={"fosetyl_al_count"} />
                  <TotalTd rows={data.rows} field={"dithianon_count"} />
                </Fragment>
              )}
            </tr>
            <tr className="percentage_row">
              <td colSpan={attribute_types.length} className="total_title">
                Percentage %
              </td>
              <PercentageTd total rows={data.rows} field={"samples_tested"} />
              <PercentageTd rows={data.rows} field={"residue_free"} />
              <PercentageTd rows={data.rows} field={"with_residues"} />
              <PercentageTd rows={data.rows} field={"one_to_two_residues"} />
              <PercentageTd rows={data.rows} field={"three_to_five_residues"} />
              <PercentageTd rows={data.rows} field={"more_than_five_residues"} />
              <PercentageTd rows={data.rows} field={"insecticide_free_count"} />
              <PercentageTd rows={data.rows} field={"fungicide_free_count"} />

              <ResiduePercentageTd total rows={data.rows} field={"residues_found"} />
              <ResiduePercentageTd rows={data.rows} field={"no_mrl"} />
              <ResiduePercentageTd rows={data.rows} field={"less_than_20_percent"} />
              <ResiduePercentageTd rows={data.rows} field={"twenty_to_fifty_percent"} />
              <ResiduePercentageTd rows={data.rows} field={"fifty_to_eighty_percent"} />
              <ResiduePercentageTd rows={data.rows} field={"eighty_to_hundred_percent"} />
              <ResiduePercentageTd rows={data.rows} field={"above_the_mrl"} />

              {options.showTestingBreakdown && (
                <Fragment>
                  <PercentageTd rows={data.rows} field={"mrps_gc_lc_dithio_count"} />
                  <PercentageTd rows={data.rows} field={"chlorate_count"} />
                  <PercentageTd rows={data.rows} field={"fosetyl_al_count"} />
                  <PercentageTd rows={data.rows} field={"dithianon_count"} />
                </Fragment>
              )}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
